import * as React from 'react';

import { useFeatureFlags } from '@context/launch-darkly/LDProvider';

export const SwogoScript = () => {
  const { swogoIntegrationEnabled } = useFeatureFlags();

  if (!swogoIntegrationEnabled) {
    return null;
  }

  return <div id="swogo-bundle-1" className="swogo-box" />;
};
